<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="1500px">
      <template v-slot:activator="{ on, attrs }">
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn text medium icon v-bind="attrs" v-on="on">
              <v-icon medium color="white lighten-1"> mdi-plus-circle </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <v-card>
        <v-row>
          <v-col cols="12" class="d-flex justify-center">
            <v-card-title>
              <span class="headline">Registro de Transferência</span>
            </v-card-title>
          </v-col>
        </v-row>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="5" lg="5" xl="5">
                <v-card max-width="100%" class="elevation-0">
                  <v-data-table
                    :headers="headers"
                    :items="assets"
                    :items-per-page="5"
                    :search="search"
                    :custom-filter="filterAssets"
                  >
                    <template v-slot:top>
                      <v-text-field v-model="search" label="Pesquisar" class="mx-4"></v-text-field>
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">
                      <v-btn text medium icon @click="selectAssetToTransfer(item.id)">
                        <v-icon v-if="!item.selected" medium color="red lighten-1">
                          mdi-arrow-right
                        </v-icon>
                        <v-icon v-else-if="item.selected" medium color="red lighten-1">
                          mdi-arrow-left
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>

              <v-divider vertical class="hidden-sm-and-down"></v-divider>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-form ref="transfer_form">
                  <v-row>
                    <v-col cols="11" class="ml-0 pl-0">
                      <v-subheader>Registro de Transferencia </v-subheader>
                    </v-col>
                    <v-col cols="1" class="mt-2">
                      <v-icon medium color="red lighten-1">
                        mdi-arrow-down-drop-circle-outline
                      </v-icon>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                      <v-select
                        v-model="$v.form.movement_type_id.$model"
                        hide-details
                        :items="movement_types"
                        item-value="id"
                        item-text="choice"
                        label="Tipo de Transferencia*"
                        :error-messages="errors.data.movement_type_id"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="$v.form.movement_date.$model"
                            label="Data de Transferencia*"
                            prepend-icon="mdi-calendar"
                            readonly
                            color="red lighten-1"
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="errors.data.movement_date"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="$v.form.movement_date.$model" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                          <v-btn text color="primary" @click="$refs.menu.save(date)"> OK </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                      <v-select
                        v-model="$v.form.reciever_entity_id.$model"
                        hide-details
                        :items="entities"
                        item-value="id"
                        item-text="workstation"
                        label="Instituição Destino*"
                        :error-messages="errors.data.reciever_entity_id"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                      <v-select
                        v-model="$v.form.reciever_department_id.$model"
                        hide-details
                        item-value="id"
                        item-text="department"
                        label="Departamento Destino"
                        :items="departments"
                        :error-messages="errors.data.reciever_department_id"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row class="ml-1 mt-2">
                    Equipamentos Selecionados para Tranferência: <br />
                  </v-row>
                  <v-row class="mb-4 ml-2">
                    <v-card
                      v-for="selected_asset in selected_assets"
                      :key="selected_asset.id"
                      class="d-flex"
                    >
                      <v-chip
                        class="ma-2"
                        color="red lighten-1"
                        label
                        text-color="white"
                        close
                        @click:close="selectAssetToTransfer(selected_asset.id)"
                      >
                        {{ selected_asset.asset_number }} - {{ selected_asset.item_description }}
                      </v-chip>
                    </v-card>
                  </v-row>
                  <small>*Indica Campos Obrigátorios</small>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="close()"> Fechar </v-btn>
          <v-btn color="black" text @click="storeMovement()"> Salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'

export default {
  name: 'NewTransfer',
  directives: { mask },
  data: () => ({
    search: '',
    selected_assets: [],
    assets_treated: [],
    headers: [
      {
        text: 'Nº de Tombo',
        align: 'start',
        value: 'asset_number',
      },
      { text: 'Nome', value: 'item_description' },
      { text: ' ', value: 'actions', sortable: false },
    ],

    dialog: false,
    menu: false,
    date: new Date().toISOString().substr(0, 10),
    form: {
      movement_date: '',
      movement_type_id: '',
      reciever_entity_id: '',
      reciever_department_id: [],
    },
    errors: {
      messages: {
        required: 'O campo e obrigatorio',
      },
      data: {
        movement_date: [],
        movement_type_id: [],
        reciever_entity_id: [],
        reciever_department_id: [],
      },
    },
  }),
  validations: {
    form: {
      movement_date: { required },
      movement_type_id: { required },
      reciever_entity_id: { required },
      reciever_department_id: {},
    },
  },
  watch: {
    assets: function () {
      this.assets_treated = this.GET_assetsWithoutTranfered()
    },
  },
  created() {
    this.assets_treated = this.GET_assetsWithoutTranfered()
  },
  computed: {
    ...mapState('assets', ['assets']),
    ...mapState('entities', ['entities']),
    ...mapState('movements', ['movements', 'movement_types']),
    ...mapState('departments', ['departments']),
    ...mapState('auth', ['user']),
  },
  methods: {
    ...mapGetters('assets', ['GET_assetsWithoutTranfered']),
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('movements', ['ActionStoreMovement']),
    ...mapMutations('assets', ['SET_assets']),

    selectAssetToTransfer(asset_id) {
      let manipulator = []
      this.assets.map((asset) => {
        if (asset.id == asset_id) {
          if (!!asset.selected) {
            asset.selected = false

            manipulator = [
              ...this.selected_assets.filter((filtered) => {
                return filtered.id !== asset_id
              }),
            ]
            this.selected_assets = manipulator
          } else {
            manipulator = [...this.selected_assets]
            asset.selected = true

            manipulator.push(
              this.assets.find((asset) => {
                return asset.id === asset_id
              })
            )
            this.selected_assets = manipulator
          }
        }
      })
    },

    async storeMovement() {
      this.ActionSetLoading(true)
      try {
        if (!this.$v.$invalid) {
          let index = 0
          let treated_form = new FormData()
          treated_form.append('movement_date', this.form.movement_date)
          treated_form.append('movement_type_id', this.form.movement_type_id)
          treated_form.append('reciever_entity_id', this.form.reciever_entity_id)
          treated_form.append('reciever_department_id', this.form.reciever_department_id)
          treated_form.append('user_id', this.user.id)
          this.selected_assets.map((asset) => {
            treated_form.append('assets[' + index + ']', asset.id)
            index = index + 1
          })

          await this.ActionStoreMovement(treated_form)
          this.$swal({
            icon: 'success',
            title: 'Cadastrado',
            text: 'Transferencia registrada com sucesso',
          })
          this.close()
        }
      } catch (error) {
        if (error.body) {
          if (error.status != 422) {
            this.$swal({
              icon: 'error',
              title: 'Erro',
              text: error.body.message,
            })
          }
          if (error.body.errors) {
            Object.keys(error.body.errors).map((key) => {
              this.errors.data[key] = error.body.errors[key]
            })
          }
        }
      }

      this.ActionSetLoading(false)
    },

    filterAssets(value, search, item) {
      search = search.toUpperCase()

      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search) !== -1
      )
    },

    close() {
      this.selected_assets = []
      let manipulator = [...this.assets]
      manipulator.map((asset) => {
        asset.selected = false
      })
      this.SET_assets(manipulator)
      this.$refs.transfer_form.reset()
      this.dialog = false
    },
    errorMensage(key) {
      const errors = []
      if (key == 'id') return
      if (!this.$v.form[key].$dirty) return errors

      if (this.$v.form[key].required !== undefined)
        !this.$v.form[key].required && errors.push(this.errors.messages.required)

      if (this.$v.form[key].minLength !== undefined)
        !this.$v.form[key].minLength &&
          errors.push(this.errors.messages.minLength(this.$v.form[key].$params.minLength.min))

      if (this.$v.form[key].maxLength !== undefined)
        !this.$v.form[key].maxLength &&
          errors.push(this.errors.messages.maxLength(this.$v.form[key].$params.maxLength.max))

      if (this.$v.form[key].email !== undefined)
        !this.$v.form[key].email && errors.push(this.errors.messages.email)

      this.errors.data[key] = errors
    },
  },
}
</script>
